<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-beat" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>

<div class="product-modal" id="lead-showrooms" role="document" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-height" role="document">
    <div class="modal-content">


      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLongTitle">
          Edit Order</h3>
        <button type="button" class="close" (click)="hideDialog()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        
        <div class="row align-items-center  no-gutters">
          <div class="col-md-12">
            <div class="popup-left">
              <form [formGroup]="editOrderForm" novalidate (ngSubmit)="onFormSubmit()">
                <div class="modal-form-container">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>First Name</label>
                      <input type="text" name="first_name" class="form-control" placeholder="" formControlName="first_name">
                    </div>
                    <div class="form-group col-md-6">
                      <label>Last Name</label>
                        <input type="text" name="last_name" class="form-control" placeholder="" formControlName="last_name">
                    </div>
                    <div class="form-group col-md-6">
                      <label>Email</label>
                      <input type="text" name="email" class="form-control" placeholder="" formControlName="email">
                    </div> 
                    <div class="form-group col-md-6">
                        <label>Phone</label>
                        <input type="text" name="phone" class="form-control" placeholder="" formControlName="phone">
                    </div> 
                    <div class="form-group col-md-12">
                      <label>Status</label>
                      <select name="state" class="form-control" formControlName="state">
                        <option value="">-</option>
                        <option value="Pending">Pending</option>
                        <option value="In-Progress">In-Progress</option>
                        <option value="Shipped">Shipped</option>
                      </select>
                    </div> 
                    <div class="form-group col-md-12">
                      <label>Shipping Address</label>
                      <input type="text" name="shipping_address" class="form-control" placeholder="" formControlName="shipping_address">
                    </div>
                  </div>

                </div>
                <div class="col-md-12 text-center pt-2">
                    <button class="btn btn-info" type="submit">Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
